import classNames from 'classnames';
import React, { type AriaAttributes } from 'react';
import { NavLink } from 'react-router-dom';

import styles from './IconButton.module.scss';

type Props = AriaAttributes & {
  onClick?: (event?: React.MouseEvent<HTMLDivElement>) => void;
  onBlur?: () => void;
  children: JSX.Element;
  tabIndex?: number;
  className?: string;
  to?: string;
  disabled?: boolean;
};

const IconButton: React.FC<Props> = ({ children, onClick, tabIndex = 0, className, to, disabled, ...ariaProps }: Props) => {
  if (to) {
    return (
      <div
        className={classNames(styles.iconButton, className, { [styles.disabled]: disabled })}
        onClick={disabled ? undefined : onClick}
        role="button"
        tabIndex={tabIndex}
        onKeyDown={(event: React.KeyboardEvent) => {
          if ((event.key === 'Enter' || event.key === ' ') && tabIndex >= 0 && onClick) {
            onClick();
            event.preventDefault(); // prevent click being called when this component unmounts
          }
        }}
        {...ariaProps}
      >
        <NavLink to={to} style={{ color: 'white', height: '24px' }}>
          {children}
        </NavLink>
      </div>
    );
  }
  return (
    <div
      className={classNames(styles.iconButton, className, { [styles.disabled]: disabled })}
      onClick={disabled ? undefined : onClick}
      role="button"
      tabIndex={tabIndex}
      onKeyDown={(event: React.KeyboardEvent) => {
        if ((event.key === 'Enter' || event.key === ' ') && tabIndex >= 0 && onClick) {
          onClick();
          event.preventDefault(); // prevent click being called when this component unmounts
        }
      }}
      {...ariaProps}
    >
      {children}
    </div>
  );
};

export default IconButton;
